import { api } from "./client";

// Party Surfaces (F7) — the global entity Review Queue. One row per portal
// account across the six party types (Buyer / Seller / Vendor / Broker /
// Brokerage / Tps), rolling up its collection-review workload. Mirrors the
// backend contract on GET /api/collection/review-queue/entities.

export interface ReviewQueueEntityRow {
  portalUserId: string;
  accountType: string;
  displayName: string;
  email: string;
  // The linked party record (Broker.Id, Vendor.Id, …). Null for accounts
  // with no resolved entity — those rows fall back to the portal-account
  // admin page.
  entityType: string | null;
  entityId: string | null;
  awaitingReviewCount: number;
  overdueCount: number;
  oldestOverdueAgeDays: number | null;
  pendingRecipientCount: number;
  returnedCount: number;
  lastActivityAt: string | null;
  assignedToUserIds: string[];
}

export type ReviewQueueStatusFilter =
  | "awaiting"
  | "overdue"
  | "pending"
  | "returned";

export type ReviewQueueSortBy =
  | "mostOverdue"
  | "oldest"
  | "mostOutstanding"
  | "lastActivity";

export interface ReviewQueueEntitiesQuery {
  accountType?: string;
  status?: ReviewQueueStatusFilter;
  assignedToUserId?: string;
  search?: string;
  overdueOnly?: boolean;
  activityFrom?: string;
  activityTo?: string;
  // Default mostOverdue server-side.
  sortBy?: ReviewQueueSortBy;
  offset?: number;
  limit?: number;
}

export interface ReviewQueueEntitiesResponse {
  items: ReviewQueueEntityRow[];
  total: number;
}

export const collectionReviewQueueApi = {
  entities: (query: ReviewQueueEntitiesQuery = {}) =>
    api.get<ReviewQueueEntitiesResponse>(
      "/collection/review-queue/entities",
      query,
    ),
};
